<template>
  <div
    :class="b()"
    :style="{ backgroundImage: `url(${require('@/assets/welcome/background.png')})`}"
  >
    <router-view></router-view>
  </div>
</template>

<script>
import theme from '@zk/theme/lib/variables.scss';
export default {
  name: 'OverseasGuideLayout',
  components: {

  },
  props: {

  },
  data() {
    return {
      bemNS: theme.bemNS
    };
  },
  computed: {

  },
  watch: {

  },
  created() {

  },
  mounted() {

  },
  methods: {

  }
};
</script>

<style scoped lang="scss">
  @include b(overseas-guide-layout){
    width: 100%;
    height: 100%;
    background-size: cover;
  }
</style>
